import { Popover } from 'antd';
import React from 'react';

import BookCard from '@/components/ZAIChatLayout/SourceDrawer/BookCard';

interface CitationPopoverProps {
  id: number;
  sourceDocument: any;
  children: React.ReactNode;
}

const CitationPopover: React.FC<CitationPopoverProps> = ({
  sourceDocument,
  children,
}) => {
  return (
    <Popover
      placement='top'
      trigger='hover'
      mouseEnterDelay={0.15}
      mouseLeaveDelay={0.1}
      classNames={{
        body: 'p-0 bg-transparent  ',
        root: 'bg-transparent sm:px-0 px-3',
      }}
      content={
        <div className='w-full sm:max-w-[320px] max-w-full sm:min-w-[320px] min-w-full bg-transparent'>
          <BookCard className='m-0' sourceDocument={sourceDocument} />
        </div>
      }
    >
      {children}
    </Popover>
  );
};

export default CitationPopover;
